import { useNavigate } from "react-router";
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, createFilterOptions } from "@mui/material";
import { useStateValue } from "../../context/StateValueContext";
import type { MiniCompany } from "../../types/company";
import { companySearchText } from "../../utils/companyUtils";
import { PLAIN_BUTTONS } from "./buttons";

const filterCompanies = createFilterOptions<MiniCompany>({ limit: 8, stringify: companySearchText });

export default function ExistingCompanyDialog({ openByCompany, onClose }: { openByCompany: Map<number, number>; onClose: () => void }) {
  const [{ miniCompanies }] = useStateValue();
  const navigate = useNavigate();
  const open = (company: MiniCompany) => {
    const openId = openByCompany.get(company.id);
    navigate(openId ? `/onboarding/${openId}` : `/onboarding/new/${company.id}`);
  };

  return (
    <Dialog open fullWidth maxWidth="sm" sx={PLAIN_BUTTONS} onClose={(_, reason) => { if (reason !== "backdropClick") onClose(); }}>
      <DialogTitle sx={{ pb: 0.5 }}>Start an onboarding for an existing company</DialogTitle>
      <DialogContent>
        <Autocomplete
          options={miniCompanies} filterOptions={filterCompanies} getOptionLabel={(c) => c.name} autoHighlight sx={{ pt: 1 }}
          noOptionsText="No company matches."
          onChange={(_, company) => company && open(company)}
          renderOption={({ key, ...props }, c) => (
            <li key={key} {...props}>
              <span className="flex w-full justify-between gap-3">
                <span>{c.name}</span>
                {openByCompany.has(c.id) && <span className="text-gray-500">onboarding in progress</span>}
              </span>
            </li>
          )}
          renderInput={(params) => (
            <TextField {...params} label="Company" placeholder="Type a company name" size="small" autoFocus />
          )}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
